import { BaseApiError } from "@/errors/api/base-api-error";

/**
 * APIネットワークエラー
 */
export class ApiNetworkError extends BaseApiError {
  /**
   * コンストラクタ
   */
  constructor(message: string) {
    super(message);
  }
}
